
export default {
// Customer Name--模糊查询
// Mobile Number--精确匹配
// Certificate Type 证件类型--精确匹配
// Account No.账户编码--精确匹配
// Email客户默认联系人email--精确匹配
// Service Number订户号码 服务号--精确匹配
  searchTypeOptionList: [{
    labelKey: 'SEARCH_CUSTOMER_NAME',
    value: 'custName',
  }, {
    labelKey: 'SEARCH_MOBILE_NUMBER',
    value: 'contactMobilePhone',
  }, {
    labelKey: 'SEARCH_CERTIFICATE_TYPE',
    value: 'certNbr',
  }, {
    labelKey: 'SEARCH_ACCOUNT_NO',
    value: 'acctNbr',
  }, {
    labelKey: 'SEARCH_Email',
    value: 'email',
  }, {
    labelKey: 'SEARCH_PHONE_NUMBER',
    value: 'msisdn',
  }],
  formItemLayout: {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
  },
};
